module.exports = __webpack_public_path__ + "static/img/10.d7c5afc6.jpg";